import { device } from "web_myplann/Utils/device";
import type { HandleDocumentTypes } from "web_myplann/Utils/WebViewModel";

export type HandleDocumentOnDeviceParams = {
	base64: string;
	filename: string;
	mimeType?: string;
	actionType: keyof typeof HandleDocumentTypes;
	errorMessage: string;
};

export const handleDocumentOnDevice = async ({
	base64,
	filename,
	mimeType,
	actionType,
	errorMessage,
}: HandleDocumentOnDeviceParams): Promise<void> => {
	const response = await device.handleDocument({
		file: { base64, filename },
		actionType,
		mimeType,
	});

	if (!response.payload.success) {
		throw new Error(errorMessage);
	}
};
